import { OrbitCamera as t } from "./components.js";
import { orbitCameraRecipe as e } from "./recipes.js";
import { OrbitCameraSetupSystem as r, OrbitCameraInputSystem as i, OrbitCameraSystem as a } from "./systems.js";
const n = {
  systems: [r, i, a],
  recipes: [e],
  components: {
    OrbitCamera: t
  },
  config: {
    defaults: {
      "orbit-camera": {
        target: 0,
        inputSource: 0,
        currentDistance: 4,
        targetDistance: 4,
        currentYaw: 0,
        targetYaw: 0,
        currentPitch: Math.PI / 6,
        targetPitch: Math.PI / 6,
        minDistance: 1,
        maxDistance: 25,
        minPitch: 0,
        maxPitch: Math.PI / 2,
        smoothness: 0.5,
        offsetX: 0,
        offsetY: 1.25,
        offsetZ: 0,
        sensitivity: 7e-3,
        zoomSensitivity: 1.5
      }
    }
  }
};
export {
  n as OrbitCameraPlugin
};
//# sourceMappingURL=plugin.js.map
